export function Chip({
  label,
  onDismiss,
  onClick,
  className,
  dismissible,
  size = "md",
  bgColor,
}) {
  const sizeClass = {
    xs: "px-2 py-1 text-xs",
    sm: "px-2 py-1 text-sm",
    md: "px-2.5 py-1.5 text-sm",
    lg: "px-3 py-2 text-sm",
    xl: "px-3.5 py-2.5 text-sm",
  };
  return (
    <div
      onClick={() => {
        onClick && onClick();
      }}
    >
      <div
        className={`${className || ""} flex flex-wrap justify-center ${
          (onClick && "cursor-pointer") || ""
        }`}
      >
        <div
          className={`chip-bg flex justify-center items-center m-1 bg-gray-800 rounded-full 
        shadow-sm text-white focus-visible:outline-gray-600 
        focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${sizeClass[size]}`}
          style={{ background: bgColor }}
        >
          <div class="label leading-none flex-initial mr-1 whitespace-nowrap">
            {label}
          </div>
          <div class="flex flex-auto flex-row-reverse">
            {dismissible && (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  onDismiss && onDismiss();
                }}
                className="ml-1 hover:bg-gray-300 rounded-full"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-x cursor-pointer hover:text-gray-800 rounded-full w-4 h-4"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
